import { useQuery } from "@tanstack/react-query";
import { getWorkspaceSubscription } from "api/services/workspace-service";
import { IWorkspaceSubscriptionModel } from "api/models/response/workspacePlan/IWorkspaceSubscriptionModel";
import { useAuthContext } from "hooks/useAuthContext";
import { WORKSPACE_SUBSCRIPTION_QUERY_KEY } from "hooks/workspacePlan/queryKeys";

export const useGetWorkspaceSubscription = () => {
    const { userState } = useAuthContext();
    const workspaceId = userState.user.selectedWorkspace.workspaceId;

    const query = useQuery({
        queryKey: [...WORKSPACE_SUBSCRIPTION_QUERY_KEY, workspaceId],
        queryFn: async (): Promise<IWorkspaceSubscriptionModel | null> => {
            if (!workspaceId) return null;

            const response = await getWorkspaceSubscription({ workspaceId });
            if (!response.success) {
                throw new Error(response.message ?? "subscriptionPlan.subscriptionLoadError");
            }

            return response.data ?? null;
        },
        enabled: !!workspaceId,
    });

    return {
        subscription: query.data ?? null,
        subscriptionLoading: query.isLoading,
        subscriptionRefetching: query.isFetching && !query.isLoading,
        subscriptionError: query.isError,
        refetchSubscription: query.refetch,
    };
};
